export function FeedSkeleton() {
  return (
    <div className="w-full animate-pulse">
      {/* Hero Skeleton */}
      <section className="grid grid-cols-1 lg:grid-cols-12 gap-px mb-12 border border-white/10 bg-white/5">
        <div className="lg:col-span-8 p-8 md:p-12 min-h-[520px] flex flex-col justify-end border-r border-white/10 bg-surface-container/20">
          <div className="flex gap-4 mb-6">
            <div className="w-24 h-5 bg-white/10" />
            <div className="w-32 h-5 bg-white/10" />
          </div>
          <div className="w-3/4 h-16 bg-white/20 mb-4" />
          <div className="w-1/2 h-16 bg-white/20 mb-8" />
          <div className="w-32 h-6 bg-white/10" />
        </div>
        
        <div className="lg:col-span-4 flex flex-col">
          {[1, 2].map((i) => (
            <div key={i} className="flex-1 p-8 flex flex-col justify-center border-b border-white/10 bg-surface-container/10">
              <div className="w-20 h-4 bg-white/10 mb-4" />
              <div className="w-full h-8 bg-white/20 mb-2" />
              <div className="w-2/3 h-8 bg-white/20 mt-auto" />
            </div>
          ))}
        </div>
      </section>

      {/* Main Content Layout */}
      <div className="flex flex-col lg:flex-row gap-8">
        {/* Feed Skeleton */}
        <div className="flex-1">
          <div className="flex items-end justify-between mb-8 border-b-2 border-secondary/30 pb-4">
            <div className="w-48 h-10 bg-white/10" />
          </div>

          <div className="space-y-4">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex flex-col md:flex-row gap-6 p-6 border border-white/10 bg-white/5">
                <div className="hidden md:flex flex-col items-center">
                  <div className="w-8 h-8 bg-white/10 rounded-full" />
                </div>
                <div className="flex-1">
                  <div className="flex gap-2 mb-3">
                    <div className="w-16 h-4 bg-white/10" />
                    <div className="w-32 h-4 bg-white/10" />
                  </div>
                  <div className="w-full h-6 bg-white/20 mb-2" />
                  <div className="w-3/4 h-6 bg-white/20 mb-4" />
                  <div className="flex gap-4">
                    <div className="w-24 h-4 bg-white/10" />
                    <div className="w-24 h-4 bg-white/10" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Sidebar Skeleton */}
        <aside className="w-full lg:w-96 flex flex-col gap-10">
          <div className="bg-surface-container/30 p-6 h-32" />
          <div>
            <div className="w-48 h-8 bg-white/10 mb-6" />
            <div className="flex flex-wrap gap-2">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="w-20 h-8 bg-white/10" />
              ))}
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}
